<div class="row">
    <label>{{field?.props?.label + (field?.props?.required ? '*' : '')}}</label>
    <mat-form-field appearance="outline" floatLabel="always" class="col-9">
        <mat-label>Address</mat-label>
        <input id="autocompletePlaces" ngx-google-places-autocomplete [options]='options' [(ngModel)]="addressFieldModel" (ngModelChange)="onModelChange($event)" #placesRef="ngx-places"
               placeholder="Enter Address" type="text" matInput (onAddressChange)="handleAddressChange($event)" />
    </mat-form-field>
</div>
